import React, { ReactNode } from "react";
import styles from "./TwoToneHorizontalSectionChild.module.css";
import Paragraph, { ParagraphSize } from "./Paragraph";

interface TwoToneHorizontalSectionChild {
  titleTone1: string;
  titleTone2: string;
  description?: string;
  children: ReactNode;
}

const TwoToneHorizontalSectionChild: React.FC<
  TwoToneHorizontalSectionChild
> = ({ titleTone1, titleTone2, description, children }) => {
  return (
    <div className={styles["parent-container"]}>
      <div className={styles["information-container"]}>
        <h1 className={styles["two-tone-heading"]}>
          <span>{titleTone1}</span>
          <span className={styles["secondary-text"]}>{titleTone2}</span>
        </h1>

        {description && (
          <Paragraph
            classNameStyle={styles["description"]}
            size={ParagraphSize.paragraph1}
          >
            {description}
          </Paragraph>
        )}
      </div>
      <>{children}</>
    </div>
  );
};

export default TwoToneHorizontalSectionChild;
